import React from 'react';
import { connect } from 'react-redux';
import { editarEmpresa, guardarEmpresa, cargarImagen } from '../../components/empresas/EmpresaService'
import { getAuthorizationHeaderUpload, getAuthorizationHeader, URL as URLService } from '../../constans/constants';
import axios from "axios";
import Resizer from "react-image-file-resizer";
import { logout } from '../login/SesionService';
import { validateForm } from "../../constans/validationUtils";
import validarImagen from "../seguridad/ValidadorImagen";
import DropzoneComponent from "../componentes/DropzoneComponent";
import BreadCrumComponent from "../componentes/BreadCrumComponent";
import MensajeFlash from "../mensajeFlash/MensajeFlash";
import PantallaCarga from '../mensajeFlash/PantallaCarga';
import {
  mostrarErroresEnFormulario, configurarLimpiezaAutomatica,
  integrarConHandleInput
} from '../../constans/form-error-utils';
 
class Empresa extends React.Component {
 
  constructor(props) {
    super(props);
 
    const { tipoAccion } = props.match.params;
 
    const originalHandleInput = this.handleInput;
 
    this.handleInput = integrarConHandleInput(this, originalHandleInput);
 
    this.state = {
      nombre: "",
      direccion: "",
      ruc: "",
      errors: {
        nombre: null,
        direccion: null,
        ruc: null,
      },
      estado: true,
      mostrarMensaje: false,
      mensaje: "",
      logo: null,
      urlLogo: '',
      openPantallaCarga: false,
 
      titulo: null,
      tipoAccion,
 
      mensajeFlash: "",
      mostrarMensajeFlash: false,
      mensajeFlashSeverity: "neutral",
      showErrors: false
    }
  }
 
  reglasValidacionCampos = {
    nombre: [
      { required: true, message: 'Campo obligatorio' },
    ],
    direccion: [
      { required: true, message: 'Campo obligatorio' },
    ],
    ruc: [
      { required: true, message: 'Campo obligatorio' },
      { customValidator: (value, formData) => /^\d+-\d{1}$/.test(value), message: "Debe ingresar un RUC valido" }
    ]
  }
 
  handleCloseMensajeFlash = () => {
    this.setState({
      mostrarMensaje: false,
    });
  };
 
  handleChange = (event) => {
    this.setState({ ...this.state, [event.target.name]: event.target.checked });
  };
 
  handleUploadLogo = async (archivo) => {
    const resultadoAnalisis = await validarImagen(archivo)
    if (resultadoAnalisis) {
      try {
        Resizer.imageFileResizer(
          archivo,
          200, 150,
          "PNG",
          0, 0,
          (uri) => {
            this.setState({
              urlLogo: URL.createObjectURL(uri),
              logo: uri
            })
          },
          "file",
        )
 
      } catch (error) {
        this.setState({
          mostrarMensajeFlash: true,
          mensajeFlash: "Ocurrio un error durante la carga de la imagen",
          mensajeFlashSeverity: "error"
        });
      }
    } else {
      this.setState({
        mostrarMensajeFlash: true,
        mensajeFlash: resultadoAnalisis.error,
        mensajeFlashSeverity: "error"
      })
    }
 
  }
 
  handleEmpresaSubmit = (e) => {
    e.preventDefault();
    const { isValid, errors } = validateForm(this.state, this.reglasValidacionCampos);
    if (isValid) {
      mostrarErroresEnFormulario({})
      this.setState({ openPantallaCarga: true, validated: true });
      if (this.state.tipoAccion === "edit") {
        const json = {
          nombre: this.state.nombre,
          direccion: this.state.direccion,
          ruc: this.state.ruc,
          id: this.state.id,
          estado: this.state.estado
        };
        this.props.editarEmpresa(json).then((response) => {
          if (response.error === true) {
            try {
              const errores = JSON.parse(response.mensaje)
              this.setState(prevState => ({
                errors: {
                  ...prevState.errors,
                  nombre: errores.nombre,
                  direccion: errores.direccion,
                  ruc: errores.ruc
                },
                openPantallaCarga: false
              }))
            } catch (e) {
              this.setState({
                mostrarMensajeFlash: true,
                mensaje: response.mensaje,
                severity: "danger",
                openPantallaCarga: false
              })
            }
          } else {
            if (this.state.logo != null) {
              var id = response.datos.id
              var formData = new FormData()
              formData.append("file", this.state.logo)
              axios.post(URLService + "empresa/subirImagen/" + id, formData, getAuthorizationHeaderUpload())
            }
            this.props.history.push({
              pathname: '/admin/empresas',
              state: {
                mensajeFlash: "Empresa modificada exitosamente",
                mostrarMensajeFlash: true,
                mensajeFlashSeverity: "exito",
              }
            })
          }
        }, error => {
          if (error.response.status === 401) {
            logout();
          }
          return error;
        });
      } else if (this.state.tipoAccion === "add") {
        const json = {
          nombre: this.state.nombre,
          direccion: this.state.direccion,
          ruc: this.state.ruc,
          estado: this.state.estado
        };
        this.props.guardarEmpresa(json).then((response) => {
          if (response.error === true) {
            try {
              const errores = JSON.parse(response.mensaje)
              this.setState(prevState => ({
                errors: {
                  ...prevState.errors,
                  nombre: errores.nombre,
                  direccion: errores.direccion,
                  ruc: errores.ruc
                },
                openPantallaCarga: false
              }))
            } catch (e) {
              this.setState({
                mostrarMensajeFlash: true,
                mensaje: response.mensaje,
                severity: "danger",
                openPantallaCarga: false
              })
            }
          } else {
            if (this.state.logo != null) {
              var id = response.datos.id
              var formData = new FormData()
              formData.append("file", this.state.logo)
              axios.post(URLService + "empresa/subirImagen/" + id, formData, getAuthorizationHeaderUpload())
            }
            this.props.history.push({
              pathname: '/admin/empresas',
              state: {
                mensajeFlash: "Empresa creada exitosamente",
                mostrarMensajeFlash: true,
                mensajeFlashSeverity: "exito",
              }
            })
          }
        }, error => {
          if (error.response.status === 401) {
            logout();
          }
          return error;
        });
      }
    } else {
      this.setState({ errors: errors, showErrors: true });
      mostrarErroresEnFormulario(errors);
    }
 
  }
 
  componentDidMount() {
    configurarLimpiezaAutomatica()
    if (this.state.tipoAccion === "edit") {
      const { empresa } = this.props.location.state;
      this.setState({
        nombre: empresa.nombre,
        direccion: empresa.direccion,
        ruc: empresa.ruc,
        id: empresa.id,
        estado: empresa.activo,
        titulo: "Datos de la empresa: " + empresa.nombre
      })
 
      axios.get(URLService + "empresa/cargarImagen/" + empresa.id, getAuthorizationHeader())
        .then(res => {
          if (res.data.error !== true) {
            this.setState({
              urlLogo: "data:image/png;base64," + res.data
            })
          }
        }, error => {
          if (error.response.status === 401) {
            logout();
          }
          return error;
        })
    }
  }
 
  handleInput = (e) => {
    var name = e.target.name
    var val = e.target.value
    this.setState(prevState => ({
      errors: {
        ...prevState.errors,
        [name]: null
      },
      [name]: val,
    }))
  }
 
  handleClose = () => {
    this.props.handleClose(false);
  }
 
  render() {
    return (
      <div>
        <header className="component-header">
          <div className="page-container">
            <BreadCrumComponent
              backUrl={'/admin/empresas'}
              breadcrumbs={
                [
                  { label: 'Empresas', path: '/admin/empresas' },
                  { label: this.props.match.params.tipoAccion !== 'edit' ? 'Nueva empresa' : 'Editar empresa', path: '' }
                ]
              }
            />
 
            <div className="head-area">
              <div className="caption-area">
                <h1 className="page-title"> {this.state.titulo ?? "Registrar nueva empresa"}  </h1>
                <p className="page-description"> Complete el siguiente formulario con los datos correspondientes </p>
              </div>
            </div>
          </div>
        </header>
        <div className="wrapperContent">
          <div className="page-container card">
            <div className="component-form">
              <div className="component-content">
                <form onSubmit={this.handleEmpresaSubmit} className="form container-sm">
 
                  <div className="form-group">
                    <input type="text" name="nombre" id="nombre" className="form-input" placeholder="" onChange={this.handleInput} value={this.state.nombre} />
                    <label htmlFor="nombre" className="form-label"> Nombre de la empresa </label>
                  </div>
 
                  <div className="form-group__inline">
 
                    <div className="form-group">
                      <input type="text" name="direccion" id="direccion" className="form-input" placeholder="" onChange={this.handleInput} value={this.state.direccion} />
                      <label htmlFor="direccion" className="form-label"> Direccion fisica </label>
                    </div>
 
                    <div className="form-group">
                      <input type="text" name="ruc" id="ruc" className="form-input" placeholder="" onChange={this.handleInput} value={this.state.ruc} />
                      <label htmlFor="ruc" className="form-label"> Nro. de RUC </label>
                    </div>
 
                    <div className="form-group">
                      <input type="checkbox" className="form-check" name="estado" id="estado" onChange={this.handleChange} checked={this.state.estado} />
                      <label htmlFor="estado" className="check-label"> Activo </label>
                    </div>
 
                  </div>
 
                  <hr />
 
                  <div className="component-carga-apariencia">
 
                    <h3 className="form-subtitle"> Logo de la empresa </h3>
                    <p className="form-description"> Selecciona el archivo de imagen como logo para la empresa </p>
                    <div className="container-flex center-content">
                      {
                        this.state.urlLogo &&
                        <div className="col">
                          <span className="form-midtitle"> Logo actual </span>
                          <div className="signature-area">
                            <img id="logoImg" src={this.state.urlLogo} className="img-fluid" alt="logo_empresa" />
                          </div>
                        </div>
                      }
 
                      <div className="col">
                        <span className="form-midtitle"> Seleccionar imagen </span>
                        <div className="carga-documento-section">
 
                          <div className="carga-documento-content">
                            <DropzoneComponent onFileSelected={this.handleUploadLogo} archivos_soportados={["png", "jpg"]} />
                          </div>
                        </div>
 
                      </div>
                    </div>
                  </div>
 
                  <div className="form-actions">
                    <button type="submit" className="btn-medium btn-primary"> Continuar </button>
                  </div>
                </form>
              </div>
            </div>
 
          </div>
        </div>
 
        <PantallaCarga mensaje={"Guardando cambios"} />
 
        <MensajeFlash
          visible={this.state.mostrarMensajeFlash}
          mensaje={this.state.mensajeFlash}
          severity={this.state.mensajeFlashSeverity} />
      </div>
    );
 
  }
 
 
}
 
const mapDispatchToProps = dispatch => ({
  guardarEmpresa: value => dispatch(guardarEmpresa(value)),
  editarEmpresa: value => dispatch(editarEmpresa(value)),
  cargarImagen: value => dispatch(cargarImagen(value)),
});
 
export default connect(null, mapDispatchToProps)(Empresa);